export var Workflow;
(function (Workflow) {
    Workflow["AddCash"] = "AddCash";
    Workflow["Buy"] = "Buy";
    Workflow["Funds"] = "Funds";
    Workflow["Receive"] = "Receive";
    Workflow["Sell"] = "Sell";
    Workflow["Send"] = "Send";
    Workflow["Transfer"] = "Transfer";
    Workflow["WithdrawCash"] = "WithdrawCash";
})(Workflow || (Workflow = {}));
